<template>
  <div
    class="d-flex align-center"
    style="height: 100%"
  >
    <v-text-field
      v-show="editMode"
      v-model="url"
      :label="label"
      :placeholder="placeholder"
      outlined
      dense
      append-icon="done"
      hide-details
      @click:append="apply"
    />
    <v-menu
      open-on-hover
      bottom
      offset-y
      allow-overflow
    >
      <template v-slot:activator="{ on }">
        <p
          v-show="!editMode"
          :class="[{ 'text-truncate': textTruncate }, 'subtitle-1', 'mt-2']"
          v-on="on"
        >
          <a
            :href="url"
            target="_blank"
          > {{ value ? url : text }}</a>
        </p>
      </template>
      <v-col class="grey lighten-4 d-flex justify-space-between align-center pa-2">
        <v-btn
          text
          @click="editMode = true"
        >
          Редагувати
          <v-icon class="ml-2">
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn text>
          <a
            :href="url"
            target="_blank"
          >
            <v-icon>open_in_new</v-icon>
          </a>
        </v-btn>
      </v-col>
    </v-menu>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: "Опис",
    },
    placeholder: {
      type: String,
      default: "Введіть Опис",
    },
    value: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "Немає опису",
    },
    textTruncate: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    editMode: false,
    url: "",
  }),
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.url = this.value;
        }
      },
      immediate: true,
    },
  },
  methods: {
    apply(){
      if (this.url){
        this.$emit("input", this.url);
        this.editMode = false;
      }
    },
  },
};
</script>